import { HoverSliderManager } from "../managers/HoverSliderManager";

export class HoverSliderObserver {
  constructor() {
    this.observer = new MutationObserver(this._handleMutations.bind(this));
    this.observeDocument();
    this.initExistingElements();
  }

  observeDocument() {
    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  initExistingElements() {
    document.querySelectorAll('[data-hover-slider]').forEach((elem) => {
      if (!elem.hoverSliderManagerInstance) {
        new HoverSliderManager({ elem });
      }
    });
  }

  _handleMutations(mutationsList) {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Если сам узел имеет атрибут data-hover-slider
            if (node.matches && node.matches('[data-hover-slider]')) {
              if (!node.hoverSliderManagerInstance) {
                new HoverSliderManager({ elem: node });
              }
            }

            // Если вложенные элементы имеют data-hover-slider
            node.querySelectorAll?.('[data-hover-slider]').forEach((inner) => {
              if (!inner.hoverSliderManagerInstance) {
                new HoverSliderManager({ elem: inner });
              }
            });
          }
        });
      }
    });
  }
}
